/**
 * Get the API base URL from environment variable or default
 * @returns {string} The API base URL
 */
export const getApiBaseUrl = () => {
  return process.env.REACT_APP_API_URL || "http://localhost:8000/api";
};

/**
 * Get the display base URL for showing in the UI
 * Always returns a full URL with protocol
 * @returns {string} The display base URL
 */
export const getDisplayBaseUrl = () => {
  const apiBaseUrl = getApiBaseUrl();
  return apiBaseUrl.startsWith("http")
    ? apiBaseUrl
    : `${window.location.protocol}//${window.location.host}${apiBaseUrl}`;
};

/**
 * Get the API key from environment variable
 * @returns {string|undefined} The API key if set
 */
export const getApiKey = () => {
  return process.env.REACT_APP_API_KEY;
};

/**
 * Get headers for API requests including authentication
 * @returns {Object} Headers object with API key if available
 */
export const getApiHeaders = () => {
  const headers = {
    "Content-Type": "application/json",
  };

  const apiKey = getApiKey();
  if (apiKey) {
    headers["X-API-Key"] = apiKey;
  }

  return headers;
};
